import * as types from '../constants/category';
import api from '../api';
import qs from 'qs';
import localStorage from 'store';

const setLoader = bool => dispatch =>
  dispatch({
    type: types.SET_LOADER,
    payload: bool,
  });

const setCategories = obj => dispatch =>
  dispatch({
    type: types.SET_CATEGORIES,
    payload: obj,
  });

const setProducts = arr => dispatch =>
  dispatch({
    type: types.SET_PRODUCTS,
    payload: arr,
  });

const setProductsLoader = bool => dispatch =>
  dispatch({
    type: types.SET_PRODUCTS_LOADER,
    payload: bool,
  });

const setPage = num => dispatch =>
  dispatch({ type: types.SET_PAGE, payload: num });

const fetchFilters = obj => ({
  type: types.FETCH_FILTERS,
  payload: { filters: obj.filters, total: obj.total },
});

const setFiltersLoader = bool => dispatch =>
  dispatch({
    type: types.SET_FILTERS_LOADER,
    payload: bool,
  });

const fetchMenu = () => async (dispatch, getState) => {
  try {
    dispatch(setLoader(true));
    let { data } = await api.get('/categories');
    let categories = data.data;
    dispatch(setCategories(categories));
    localStorage.set('categories', categories);
    dispatch(setLoader(false));
  } catch (e) {
    console.error(e);
    dispatch(setLoader(false));
  }
};

const fetchProducts = (nextPage = false) => async (dispatch, getState) => {
  try {
    let location = getState().user.location;
    let categoryState = getState().categories;

    let { page, perPage, products, selectedFilters, total } = categoryState;

    if (selectedFilters.categories.length === 0) {
      return;
    }

    dispatch(setProductsLoader(true));
    dispatch(setFiltersLoader(true));

    if (nextPage) {
      if (page * perPage < total) {
        page++;
        dispatch(setPage(page));
      } else {
        return false;
      }
    } else {
      products = [];
    }

    let params = {
      page,
      perPage,
      ...selectedFilters,
      latitude: location ? location.latitude : null,
      longitude: location ? location.longitude : null,
    };

    let queryString = qs.stringify(params);
    let { data } = await api.get('products', {
      params,
      paramsSerializer: () => queryString,
    });

    console.log('data', data);

    dispatch(
      fetchFilters({
        total: data.total,
        filters: data.filters,
      })
    );
    dispatch(setProducts([...products, ...data.data]));
    dispatch(setProductsLoader(false));
    dispatch(setFiltersLoader(false));
  } catch (e) {
    console.error(e);
    dispatch(setProductsLoader(false));
    dispatch(setProducts([]));
  }
};

const setSelectedFilters = filters => dispatch =>
  dispatch({
    type: types.SET_SELECTED_FILTERS,
    payload: { filters },
  });

const setFilter = ({ group, id }) => (dispatch, getState) => {
  let allSelected = getState().categories.selectedFilters;
  let exist = allSelected?.[group] || [];

  if (exist.indexOf(id) >= 0) {
    allSelected = {
      ...allSelected,
      [group]: allSelected?.[group].filter(i => i !== id),
    };
  } else {
    allSelected = {
      ...allSelected,
      [group]: exist.concat([id]),
    };
  }

  dispatch({
    type: types.SET_FILTER,
    payload: allSelected,
  });
};

const resetFilters = () => dispatch =>
  dispatch({
    type: types.RESET_FILTERS,
  });

export {
  setLoader,
  setCategories,
  setProducts,
  setProductsLoader,
  setPage,
  fetchFilters,
  setFiltersLoader,
  fetchMenu,
  fetchProducts,
  resetFilters,
  setFilter,
  setSelectedFilters,
};
